// A separate dev-server process opts in. A URL parameter alone never enables this.
export const isLocalAdminPreview = () =>
  process.env.NODE_ENV === 'development' &&
  process.env.REACT_APP_ADMIN_LOCAL_PREVIEW === 'true' &&
  ['localhost', '127.0.0.1'].includes(window.location.hostname);
